import i18next, { type Resource, type TFunction } from 'i18next'
import { options } from './i18n/config'

export default defineNuxtPlugin({
  name: 'i18n',
  dependsOn: ['language'],
  parallel: true,
  async setup({ $lang }) {
    try {
      const resources = useState<Resource>('translations', () => ({}))
      await i18next.init({
        ...options,
        lng: $lang as string,
        resources: resources.value,
      })
      return { provide: { i18next, t: i18next.t.bind(i18next) as TFunction } }
    } catch (e) {
      useLogger('plugin:i18n').error(e)
      throw e
    }
  },
})
